










import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStatisticOverdueDetail, AcgnStaticsMenu } from '@/components';

@Component({
  components: {
    AcgnStatisticOverdueDetail,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目数据 -（逾期明细-创作方）
 */
export default class StatisticStaffOverdueDetail extends Vue {

  private comicId: number = 0; // 漫画id
  private userId: number = 0; // 用户id

  private created() {
    const { id, userid } = this.$route.params;
    this.comicId = parseInt(id, 10);
    this.userId = parseInt(userid, 10);
  }
  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
